/**
 * Default landing view for the custom project.
 * Add more files under `pages/` and register routes in `App.jsx` as needed.
 */
export default function CustomProjectHome() {
  return (
    <div className="mx-auto max-w-2xl px-6 py-12">
      <h1 className="text-2xl font-bold text-slate-900">Custom project</h1>
      <p className="mt-2 text-slate-600">
        Dedicated area under <code className="rounded bg-slate-100 px-1.5 py-0.5 text-sm">src/user/custom/</code>.
        Extend with pages, components, hooks, and lib — same idea as{" "}
        <code className="rounded bg-slate-100 px-1.5 py-0.5 text-sm">user/lite/</code>.
      </p>
    </div>
  );
}
